"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitanService = void 0;
const utils_1 = require("../utils");
class TitanService {
    constructor(defaultChainId, logger, globalService, passportStorage, offChainStorage) {
        this.defaultChainId = defaultChainId;
        this.logger = logger;
        this.globalService = globalService;
        this.passportStorage = passportStorage;
        this.offChainStorage = offChainStorage;
    }
    publishPassportStats(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const start = process.hrtime.bigint();
            const passports = yield this.passportStorage.readPassports(chainId);
            const uniquePassportAddresses = [...new Set(passports.map((passport) => passport.address))];
            const passportStatsMap = {};
            // Save in map as to not require an N^2 loop for each stats update.
            // Default values provided for data continuity.
            passports.map((passport) => {
                var _a;
                passportStatsMap[passport.address.toLowerCase()] = {
                    isHuman: false,
                    creditScoreHistory: Object.assign(Object.assign({}, (((_a = passport.stats) === null || _a === void 0 ? void 0 : _a.creditScoreHistory) || {})), { [this.getNowInStringFormat()]: '0' }),
                };
            });
            const [areHumanScores, creditScores] = yield Promise.all([
                this.offChainStorage.readScores({
                    chainId,
                    protocol: 'arcx.human',
                    accounts: uniquePassportAddresses,
                }),
                this.offChainStorage.readScores({
                    chainId,
                    protocol: 'arcx.credit',
                    accounts: uniquePassportAddresses,
                }),
            ]);
            for (const humanScore of areHumanScores) {
                passportStatsMap[humanScore.account.toLowerCase()].isHuman = true;
            }
            for (const creditScore of creditScores) {
                passportStatsMap[creditScore.account.toLowerCase()].creditScoreHistory[this.getNowInStringFormat()] = creditScore.score || '0';
            }
            // Update to array that can be written to DB
            const passportUpdateProperties = Object.keys(passportStatsMap).map((address) => ({
                address,
                stats: passportStatsMap[address],
            }));
            yield this.passportStorage.createOrUpdatePassports(chainId, passportUpdateProperties);
            const end = process.hrtime.bigint();
            const mins = (0, utils_1.getProcessDurationMins)(start, end);
            this.logger.info(`TitanService::publishPassportStats => Success in ${mins.toFixed(2)} mins`);
            yield this.globalService.publishLockTrigger(chainId, 'PASSPORTSTATS', false);
        });
    }
    getNowInStringFormat() {
        return new Date().toISOString().split('T')[0];
    }
}
exports.TitanService = TitanService;
//# sourceMappingURL=TitanService.js.map